module.exports = require('./components/rate');
